import { HttpClient } from "../HttpClient";

/**
 * Get Contents Claim Status Overview
 
 */
export const GetContentsClaimStatusOverview = async ({ userId, isImpersonation = false }) => {
  try {
    // Fetch the user's assigned dashboard
    const { data: user } = await HttpClient.get(`api/users/${userId}`);
    const assignedDashboard = user.assignedDashboard;

    const { data } = await HttpClient.get("api/contents/ClaimStatusOverview", {
      params: {
        userId,
        assignedDashboard,
        isImpersonation
      },
    });

    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

// export const GetContentsClaimStatusOverview = async ({ userId, isImpersonation = false }) => {
//   try {
//     const { data } = await HttpClient.get("api/contents/ClaimStatusOverview", {
//       params: { userId, isImpersonation },
//     });
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };